/**
 * @generated SignedSource<<0cd4cbe73b589215d9a073ec9e0e4db6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModalContent_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BidPendingContent_nftItem" | "BidSuccessfulContent_nftItem" | "PlaceBidContent_nftItem">;
  readonly " $fragmentType": "NftPdpBidModalContent_nftItem";
};
export type NftPdpBidModalContent_nftItem$key = {
  readonly " $data"?: NftPdpBidModalContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpBidModalContent_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlaceBidContent_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BidPendingContent_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BidSuccessfulContent_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "2d6df60c3f1e7b759e5120558382d7f1";

export default node;
